import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Dropdown } from 'semantic-ui-react';
import _ from 'lodash';

export default function CategoryFormModal({ open, category, lookups, onSave, onCancel }) {
    const [formData, setFormData] = useState({
        name: '',
        lookupId: ''
    });

    useEffect(() => {
        if (category) {
            setFormData({
                name: category.name || '',
                lookupId: category.lookupId || ''
            });
        }
    }, [category]);

    const lookupOptions = lookups.map(lookup => ({
        key: lookup.id,
        value: lookup.id,
        text: lookup.name
    }));

    const handleSave = () => {
        if (!formData.name.trim()) return;

        const categoryData = {
            ...category,
            ...formData
        };

        onSave(categoryData);
        setFormData({ name: '', lookupId: '' });
    };

    const handleCancel = () => {
        setFormData({ name: '', lookupId: '' });
        onCancel();
    };

    return (
        <Modal open={open} size="small">
            <Modal.Header>
                {_.isEmpty(category) || category.id === 0 ? 'Create Category' : 'Edit Category'}
            </Modal.Header>
            <Modal.Content>
                <Form>
                    <Form.Field required>
                        <label>Category Name</label>
                        <Form.Input
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            placeholder="Enter category name"
                        />
                    </Form.Field>
                    <Form.Field required>
                        <label>Lookup Menu</label>
                        <Dropdown
                            placeholder="Select a lookup menu"
                            fluid
                            search
                            selection
                            options={lookupOptions}
                            value={formData.lookupId}
                            onChange={(e, { value }) => setFormData({ ...formData, lookupId: value })}
                        />
                    </Form.Field>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button
                    primary
                    onClick={handleSave}
                    disabled={!formData.name.trim() || !formData.lookupId}
                >
                    Save
                </Button>
            </Modal.Actions>
        </Modal>
    );
}
